<template>
  <div class="wrapper">
    <div class="title">速派理赔规则和流程</div>
    <div class="container">
      <div class="container-item">
        <div class="container-item-title">理赔启动条件</div>
        <div>
          1.丢失/破损包裹请于本人签收后 <span class="important">72小时</span>内填写售后理赔，他人签收<span class="important">7个自然日</span>内填写售后理赔，（顺丰本人签收<span class="important">24小时</span>他人签收 <span class="important">72小时</span>），逾期的申请因关联协议受限，我司将不予受理；<br><br>
          2.<span class="important">时效赔偿</span>，包裹清关后<span class="important">1个月内</span>未签收的包裹;<br>
          &nbsp;&nbsp;&nbsp;&nbsp;2.1此时效不包括不可控外因导致的揽收投递延误，如两会管制、疫情管制、洪涝灾害、双十一爆仓，春节货运管制等。<br>
          &nbsp;&nbsp;&nbsp;&nbsp;2.2不包括因收件信息不准确、电话无法接通、要求变更收件信息等原因导致包裹延时或丢损。<br><br>
          3.破损包裹。客户收到包裹请务必立刻开箱确认内件是否完好！！！一旦发现破损，需要妥善保管原始货物状态（含纸箱）同时拍照留存，并提供破损物品的照片，含有清晰运单的外包装的图片。如果包裹<span class="important">外包装明显破损/污染/外包装变形（外箱虽无明显破损，但有被撞皱褶痕迹）</span>，则需要联系派件公司开具的破损、变形或者少件证明；<span class="important">不能开具证明写“外包装完好”</span>。外包装完好将无法申请理赔。<br><br>
          4.内件短少，需要提供收件包裹的签收时的重量，内件照片以及含有清晰外包装的照片，特别是封口胶带细节（有无二次封箱痕迹）。<br><br>
        </div>
      </div>
      <div class="container-item">
        <div class="container-item-title">理赔流程</div>
        <div>
          1.理赔申请请通过FASTGO公众号，选择“售后服务-售后理赔”，或者可以直接联系客服进行填写；<br><br>
          2.无论是否符合理赔要求客服都将在48小时内给与答复（通过短信/电话/微信），如果符合理赔启动条件则客服将同客户确认理赔的方式和金额。<br><br>
          3.符合条件的理赔，一般5-10个工作日完成赔付。<br><br>
        </div>
      </div>
      <div class="container-item">
        <div class="container-item-title">理赔金额</div>
        <div class="table">
          <table  border="1" cellpadding="0" cellspacing="0" width="708px">
            <tr >
              <th style="width: 140px">理赔项目</th>
              <th style="width: 300px">赔付金额（最高A$200)</th>
              <th>理赔条款</th>
            </tr>
            <tr>
              <td>包裹丢失</td>
              <td>按照商品价格（1）赔付</td>
              <td>条款：（2）（3）（4）（11）</td>
            </tr>
            <tr>
              <td>内件短少</td>
              <td>按照商品价格（1）赔付</td>
              <td>条款：（2）（5）（6）（11）</td>
            </tr>
            <tr>
              <td>内件破损</td>
              <td>符和包装标准 按照商品价格（1）*100%  <br>   不符和包装标准 按照商品价格（1）*50%</td>
              <td>条款：（2）（6）（7）（8）（9）（10）（11）</td>
            </tr>
          </table>
          <!--<img src="../../../assets/compensation.png" alt="">-->
        </div>
        <div class="tips">
          备注 :*理赔的金额直接从后续运费中抵扣，内件破损和短少只按照商品价格赔付不含运费。<br>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;*包装标准：液体物品/胶囊保健品 封口处是否宽胶带等密封和加固，儿童奶粉/成人奶粉封口处应使用胶带加固，易碎品应使用气泡袋或者气柱袋保护。<br>
          &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;<span class="red-important">*特别注意：包裹包装内件需有填充物，不能裸包装，裸包装的破损视为封装不妥，不予赔付。</span><br><br>
        </div>
      </div>
      <div class="container-item">
        <div class="container-item-title">理赔条款</div>
        <div class="container-item-content">
          (1) 商品价格的定义：参考实际购买的小票，或者澳洲市场价格，非订单价格。如果客户寄件订单填写的物品信息不够详细或者商品信息错误，我公司有权则不予赔付。<br>
          (2) 包裹出库后客户要求修改收件地址，导致出现破损/丢件/短少，不予赔付。<br>
          (3) 因客观原因造成的时效延误，譬如海关查验，退运重新报关等，不予理赔。<br>
          (4) 因客户提供错误的商品信息/虚报/漏报/收件人信息不实/包裹价值超过A$200/而造成包裹被海关扣留，或者含有违禁物品包裹被销毁，不予理赔。<br>
          (5) 外包装箱完好，无开拆痕迹和二次封印痕迹的内件短少，整箱重量在运输过程中相同时，不予理赔。<br>
          (6) 外包装箱完好，海关开拆查验造成的破损不予理赔；海关查验件，不符合海关申报标准的，被直接销毁件不予理赔。<br>
          (7) 由于天气或者压力差原因导致的货品变形、融化、爆罐将不予赔偿，对于包装内固体货物受外力影响下的变形（如由于气压差成粉末状，改变其原始形状）不予理赔。如：<span class="important">Natural`s way 全系列软糖融化，Bio island全系列瓶子形变、内部融化，巧克力等相关产品融化，黑糖的爆罐以及胶囊类产品融化、粘连，口红断裂，外包装完好瓶内胶囊爆破，零食类产品因飞机气压造成爆破。</span><br>
          (8) 小安素以及类似小安素的铁皮封口奶粉（如Ensure奶粉和糖尿病奶粉），需要用气柱包装，否则不予理赔。<br>
          (9) 外箱没有破损，物品加固后出现因瓶身破损的液体外漏，从而导致包裹被污染，被污染的商品不予理赔。<br>
          (10) 请妥善加固包装液体、玻璃包装产品，如铁元、小黄瓜水、摩洛哥油、止咳水、黑糖、Jurlique、伊索、洗洁精、食用油、酵素以及瓷器等易爆易破产品。此类产品，如有破损，不予理赔<br>
          (11) 个人行李，因为是二手物品，请购买保险，保险按照价值的2%收取，没有购买保险出现的丢失，破损，不予赔付。<br><br><br>

          本服务条款解释权归FastGo速派快递公司所有。<br><br><br>

          <div class="date">生效日期：2020年7月08日</div><br><br><br>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
    export default {
        name: "compensation"
    }
</script>

<style lang="scss" scoped>
  .container{
    text-align: left;
    padding: 36px 42px 0 42px;
    line-height: 25px;
    font-size: 16px;
    color: rgb(102,102,102);
  }
  .container-item-title{
    width: 130px;
    height: 37px;
    background: rgb(51,51,51);
    text-align: center;
    line-height: 37px;
    color: #ffffff;
    border-radius: 5px;
    margin-bottom: 21px;
  }
  .table img{
    width: 708px;
  }
  .table td, .table th{
    padding: 8px;
    font-weight: bold;
    color: #000;
  }
  .tips{
    font-size: 14px;
    color: rgb(102,102,102);
    line-height: 25px;
  }
  .date{
    text-align: right;
  }
  .container-item-content{
    line-height: 32px;
    font-size: 16px;
  }
  .important{
    font-weight: bold;
  }
  .red-important{
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/view/PageService/components/compensation.vue